"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.templateReportContentsSoftDeletedList = exports.templateReportContentsSoftDeleteRestore = exports.templateReportContentsSoftDelete = exports.templateReportContentsFetch = exports.templateReportContentsDelete = exports.templateReportContentsBulkSoftDelete = exports.templateReportContentsBulkRestore = exports.templateReportContentsBulkHardDelete = exports.templateContentsUpdate = exports.templateContentsSuccess = exports.templateContentsSoftDeletedList = exports.templateContentsSoftDeleteRestore = exports.templateContentsSoftDelete = exports.templateContentsReset = exports.templateContentsList = exports.templateContentsFetch = exports.templateContentsError = exports.templateContentsDelete = exports.templateContentsBulkSoftDelete = exports.templateContentsBulkRestore = exports.templateContentsBulkHardDelete = exports.templateContentsAdd = void 0;
var _templateContents = require("./templateContents.constant");
// @flow

// common success
var templateContentsSuccess = function templateContentsSuccess(actionType, data) {
  return {
    type: _templateContents.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.templateContentsSuccess = templateContentsSuccess;
var templateContentsError = function templateContentsError(actionType, error) {
  return {
    type: _templateContents.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.templateContentsError = templateContentsError;
var templateContentsFetch = function templateContentsFetch(data) {
  return {
    type: _templateContents.actionTypes.FETCH,
    payload: data
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.templateContentsFetch = templateContentsFetch;
var templateReportContentsFetch = function templateReportContentsFetch(data) {
  return {
    type: _templateContents.actionTypes.REPORT_FETCH,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.templateReportContentsFetch = templateReportContentsFetch;
var templateContentsList = function templateContentsList(data) {
  return {
    type: _templateContents.actionTypes.LIST,
    payload: data
  };
};

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.templateContentsList = templateContentsList;
var templateContentsAdd = function templateContentsAdd(data) {
  return {
    type: _templateContents.actionTypes.ADD,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.templateContentsAdd = templateContentsAdd;
var templateContentsUpdate = function templateContentsUpdate(data) {
  return {
    type: _templateContents.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * Reset data
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.templateContentsUpdate = templateContentsUpdate;
var templateContentsReset = function templateContentsReset() {
  return {
    type: _templateContents.actionTypes.RESET
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to soft dalete data.
 */
exports.templateContentsReset = templateContentsReset;
var templateContentsDelete = function templateContentsDelete(data) {
  return {
    type: _templateContents.actionTypes.DELETE,
    payload: data
  };
};

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft dalete data.
 */
exports.templateContentsDelete = templateContentsDelete;
var templateContentsSoftDelete = function templateContentsSoftDelete(data) {
  return {
    type: _templateContents.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft dalete restore data.
 */
exports.templateContentsSoftDelete = templateContentsSoftDelete;
var templateContentsSoftDeleteRestore = function templateContentsSoftDeleteRestore(data) {
  return {
    type: _templateContents.actionTypes.SOFT_DELETE_RESTORE,
    payload: data
  };
};

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft daleted list data.
 */
exports.templateContentsSoftDeleteRestore = templateContentsSoftDeleteRestore;
var templateContentsSoftDeletedList = function templateContentsSoftDeletedList(data) {
  return {
    type: _templateContents.actionTypes.SOFT_DELETED_LIST,
    payload: data
  };
};

/**
 * bulk soft deleted
 * @param payload
 * @returns api response
 * @description this function used to bulk soft dalete data.
 */
exports.templateContentsSoftDeletedList = templateContentsSoftDeletedList;
var templateContentsBulkSoftDelete = function templateContentsBulkSoftDelete(data) {
  return {
    type: _templateContents.actionTypes.BULK_SOFT_DELETE,
    payload: data
  };
};

/**
 * bulk hard deleted
 * @param payload
 * @returns api response
 * @description this function used to bulk hard dalete data.
 */
exports.templateContentsBulkSoftDelete = templateContentsBulkSoftDelete;
var templateContentsBulkHardDelete = function templateContentsBulkHardDelete(data) {
  return {
    type: _templateContents.actionTypes.BULK_HARD_DELETE,
    payload: data
  };
};

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore data.
 */
exports.templateContentsBulkHardDelete = templateContentsBulkHardDelete;
var templateContentsBulkRestore = function templateContentsBulkRestore(data) {
  return {
    type: _templateContents.actionTypes.BULK_RESTORE,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to soft dalete data.
 */
exports.templateContentsBulkRestore = templateContentsBulkRestore;
var templateReportContentsDelete = function templateReportContentsDelete(data) {
  return {
    type: _templateContents.actionTypes.DELETE_REPORT,
    payload: data
  };
};

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft dalete data.
 */
exports.templateReportContentsDelete = templateReportContentsDelete;
var templateReportContentsSoftDelete = function templateReportContentsSoftDelete(data) {
  return {
    type: _templateContents.actionTypes.SOFT_DELETE_REPORT,
    payload: data
  };
};

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft dalete restore data.
 */
exports.templateReportContentsSoftDelete = templateReportContentsSoftDelete;
var templateReportContentsSoftDeleteRestore = function templateReportContentsSoftDeleteRestore(data) {
  return {
    type: _templateContents.actionTypes.SOFT_DELETE_RESTORE_REPORT,
    payload: data
  };
};

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft daleted list data.
 */
exports.templateReportContentsSoftDeleteRestore = templateReportContentsSoftDeleteRestore;
var templateReportContentsSoftDeletedList = function templateReportContentsSoftDeletedList(data) {
  return {
    type: _templateContents.actionTypes.SOFT_DELETED_LIST_REPORT,
    payload: data
  };
};

/**
 * bulk soft deleted
 * @param payload
 * @returns api response
 * @description this function used to bulk soft dalete data.
 */
exports.templateReportContentsSoftDeletedList = templateReportContentsSoftDeletedList;
var templateReportContentsBulkSoftDelete = function templateReportContentsBulkSoftDelete(data) {
  return {
    type: _templateContents.actionTypes.BULK_SOFT_DELETE_REPORT,
    payload: data
  };
};

/**
 * bulk hard deleted
 * @param payload
 * @returns api response
 * @description this function used to bulk hard dalete data.
 */
exports.templateReportContentsBulkSoftDelete = templateReportContentsBulkSoftDelete;
var templateReportContentsBulkHardDelete = function templateReportContentsBulkHardDelete(data) {
  return {
    type: _templateContents.actionTypes.BULK_HARD_DELETE_REPORT,
    payload: data
  };
};

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore data.
 */
exports.templateReportContentsBulkHardDelete = templateReportContentsBulkHardDelete;
var templateReportContentsBulkRestore = function templateReportContentsBulkRestore(data) {
  return {
    type: _templateContents.actionTypes.BULK_RESTORE_REPORT,
    payload: data
  };
};
exports.templateReportContentsBulkRestore = templateReportContentsBulkRestore;